export default __webpack_public_path__ + "static/media/cashTxn.2b0a3403.svg";